<!--
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    xander<luoxingzhang@frippler.com>
  | @Title:     数据下载中心
  | @Version:   2020-07-21  [A] 新建文件
  +--------------------------------------------------------------------------------------
-->

<template>
  <div>
    <el-card shadow="never" class="card">
      <el-scrollbar :native="false">
        <el-tabs v-model="activeIndex" class="ml-sm pr el-menu-demo" @tab-click="handleSelect">
          <el-tab-pane :lazy="true" label="下载记录" name="1"> </el-tab-pane>
          <el-tab-pane :lazy="true" label="自动备份设置" name="2"> </el-tab-pane>
        </el-tabs>
        <div class="line"></div>
        <el-table v-if="activeIndex === '1'" ref="downloadref" v-loading="loading" :data="downloadList"
          tooltip-effect="dark" style="width: 100%" height="680" class="padding-large">
          <el-table-column label="生成时间" width="180">
            <template slot-scope="scope">
              <span class="text-muted">{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</span>
            </template>
          </el-table-column>

          <el-table-column :show-overflow-tooltip="true" label="数据名称" min-width="300">
            <template slot-scope="scope">
              <span class="text-muted">{{ scope.row.subject }}</span>
            </template>
          </el-table-column>

          <el-table-column label="打包进度" min-width="400">
            <template slot-scope="scope">
              <div>
                <el-progress :percentage="scope.row.status ? 100 : 50" :class="{ 'f-progress': !scope.row.status }"
                  :stroke-width="8" :show-text="true" />
              </div>
            </template>
          </el-table-column>

          <el-table-column label="大小" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.filesize" class="text-muted">{{ scope.row.filesize | byteSize }}</span>
              <span v-else class="text-muted">未知</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button v-if="!scope.row.status" size="mini" plain @click="deleteData(scope.row)">取消</el-button>
              <el-button v-else-if="scope.row.total_download" type="text"
                @click="downloadData(scope.row)">下载</el-button>
              <el-button v-else size="mini" type="primary" @click="downloadData(scope.row)">下载</el-button>
            </template>
          </el-table-column>

          <el-table-column width="60" align="center">
            <template slot-scope="scope">
              <el-link v-if="scope.row.status" class="hover-show" :underline="false" @click="deleteData(scope.row)"><i
                  class="el-icon-close"></i></el-link>
            </template>
          </el-table-column>

          <template slot="append" v-if="activeIndex === '1'">
            <f-table-footer v-if="activeIndex === '1'">
              <template slot="right">
                <f-pagination :total="total" :sizes-show="false" :pindex.sync="query.pindex" :psize.sync="query.psize"
                  @change="fetchData" />
              </template>
            </f-table-footer>
          </template>
          <template slot="empty">
            <div class="flex-center mt-hg">
              <img src="../../../assets/no-data.png" alt="" class="no-data">
            </div>
          </template>
        </el-table>
        <div v-if="activeIndex === '2'" class="mt ml-sm mb"><el-button type="success" @click="openShow(false)">+
            新建策略</el-button><span class="ml-lg text-muted text-bold">（自动备份为高级功能，限时免费体验）</span></div>
        <el-table v-if="activeIndex === '2'" ref="downloadref" v-loading="loading" :data="planList"
          tooltip-effect="dark" style="width: 100%" height="615" :row-style="{ height: '154px' }" class="padding-large">
          <el-table-column label="备份策略" min-width="180">
            <template slot-scope="scope">
              <div class="flex column">
                <div class="mb textstyle text-bold">
                  {{ scope.row.subject }}
                  <el-tooltip v-if="scope.row.invalid" placement="top">
                    <div slot="content">
                      <span v-if="scope.row.invalid">失效原因：{{ scope.row.invalid_reason }}</span>
                      <span v-else></span>
                    </div>
                    <span class="ml-sm font-lg middle text-danger"><i class="el-icon-warning" /></span>
                  </el-tooltip>
                </div>
                <div>
                  <span class="text-muted mr-lg">设备名称</span><span>{{ scope.row.equip_name }}</span>
                </div>
                <div class="mt-xs">
                  <span class="text-muted mr-lg">备份时间</span><span>{{
                    week[scope.row.weekday] + ' ' + scope.row.time[0] +
                      ':' + scope.row.time[1]
                  }}</span>
                </div>
                <div class="mt-xs">
                  <span class="text-muted mr-lg">策略描述</span><span>{{ scope.row.desc }}</span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <div class="flex">
                <el-button type="text" @click="openShow(scope.row)">编辑</el-button>
                <el-button size="mini" type="text" @click="deletePlan(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>

          <template slot="append" v-if="activeIndex === '2'">
            <f-table-footer v-if="activeIndex === '2'">
              <template slot="right">
                <f-pagination :total="plantotal" :sizes-show="false" :pindex.sync="query2.pindex"
                  :psize.sync="query2.psize" @change="fetchpalndata" />
              </template>
            </f-table-footer>
          </template>
          <template slot="empty">
            <div class="flex-center mt-hg">
              <img src="../../../assets/no-data.png" alt="" class="no-data">
            </div>
          </template>
        </el-table>
      </el-scrollbar>
    </el-card>
    <cron-post v-if="postDialogShow" :show.sync="postDialogShow" :planid="currentPlanid" @success="onPostCronSuccess" />
  </div>
</template>

<script>
import { dataListApi, downloadDataApi, deleteDataApi, PlanListApi, deletePlanApi } from '@/api/rms/rmsDownloadApi'
export default {
  components: {
    CronPost: () => import('./CronPost.vue')
  },
  data() {
    return {
      loading: false,
      downloadList: [],
      activeIndex: '1',
      postDialogShow: false,
      week: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      currentPlanid: null,
      planList: [],
      query: {
        pindex: 1,
        psize: 10
      },
      query2: {
        pindex: 1,
        psize: 10
      },
      total: 0,
      plantotal: 0,
      timer: null,
      flag: false
    }
  },
  created() {
    this.fetchData()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    fetchData(page) {
      if (page) this.query.pindex = page
      dataListApi(this.query).then(res => {
        if (!res.errno) {
          this.total = res.data.total
          this.downloadList = res.data.list
          // 判断是否有任务在打包中，通过定时器更新数据
          res.data.list.forEach(item => {
            if (!this.flag) {
              if (item.status === 0) {
                this.flag = true
                clearTimeout(this.timer)
                this.timer = setTimeout(() => {
                  this.flag = false
                  this.fetchData()
                }, 10000)
              } else {
                clearTimeout(this.timer)
              }
            }
          })
        }
      })
    },
    fetchpalndata(page) {
      if (page) this.query2.pindex = page
      PlanListApi(this.query2).then(res => {
        if (!res.errno) {
          this.plantotal = res.data.total

          this.planList = res.data.list
        }
      })
    },
    onPostCronSuccess() {
      this.fetchpalndata(1)
    },

    openShow(item) {
      if (item) {
        this.currentPlanid = item.planid
      } else {
        this.currentPlanid = null
      }
      this.postDialogShow = true
    },

    deletePlan(data) {
      this.$confirm(`即将删除<span class="text-danger">「${data.equip_name}」的自动备份策略</span>，是否继续？`, '提示', {
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        let query = {
          planid: data.planid
        }
        deletePlanApi(query).then(res => {
          if (!res.errno) {
            this.$message.success('删除成功')
            this.fetchpalndata(1)
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },

    handleSelect(tab, event) {
      this.activeIndex = tab.name
      if (tab.name === '2') {
        this.fetchpalndata()
      } else {
        this.fetchData()
      }
    },

    deleteData(data) {
      this.$confirm(`即将删除下载任务<span class="text-danger">「${data.subject}」</span>，是否继续？`, '提示', {
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        deleteDataApi({ id: data.id }).then(res => {
          if (res.errno === 0) {
            this.$message.success('删除成功')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },

    downloadData(data) {
      downloadDataApi({ id: data.id }).then(res => {
        if (!res.errno) {
          window.location.href = data.file_url
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .card {
      border: none;
    }
/deep/ .el-menu-demo {
  .el-tabs__nav-wrap::after {
    display: none;
  }

  .el-tabs__item {
    font-size: 20px;
  }
}

.textstyle {
  width: 100%;
  height: 100%;
  color: rgba(16, 16, 16, 100);
  font-size: 16px;
  text-align: left;
  font-weight: bold;
  font-family: SourceHanSansSC-regular;
}

.no-data {
  width: 200px;
  height: 200px;
}
</style>
